var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showPriceBlock || _vm.loyaltyProgram
    ? _c(
        "div",
        { staticClass: "d-flex flex-column ga-3" },
        [
          _vm.showPriceBlock
            ? _c(_setup.DoctorPriceTabs, {
                attrs: { value: _vm.value, "min-prices": _vm.minPrices },
                on: {
                  input: function ($event) {
                    return _setup.emit("input", $event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loyaltyProgram
            ? _c(_setup.LpuLoyaltyProgram, {
                attrs: {
                  "use-label": "",
                  "bonus-levels": _vm.loyaltyProgram.levels,
                  "welcome-bonus-amount":
                    _vm.loyaltyProgram.welcome_bonus_amount,
                  "max-payment-percent": _vm.loyaltyProgram.max_payment_percent,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }